import axios from 'axios'
import store from '../store'

import { EventBus } from '@/mixins/shared/event-bus'

const createRepository = (baseDomain, skipLoading = false) => {
  const baseURL = `${baseDomain}`
  const httpClient = axios.create({ baseURL })
  httpClient.interceptors.request.use((config) => {
    if (!skipLoading) {
      EventBus.$emit('loading', true)
    }
    config.headers.Authorization = `Bearer ${store.getters['oidcStore/oidcAccessToken']}`
    return config
  }, (error) => {
    if (!skipLoading) {
      EventBus.$emit('loading', false)
    }
    return Promise.reject(error)
  })

  httpClient.interceptors.response.use((response) => {
    if (!skipLoading) {
      EventBus.$emit('loading', false)
    }
    return response
  }, (error) => {
    if (!skipLoading) {
      EventBus.$emit('loading', false)
    }
    return Promise.reject(error)
  })

  return httpClient
}

export default createRepository
